import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { backend_url } from "../../App";
import { FiArrowUpRight } from "react-icons/fi";
import HeaderTitle from "../HederTitle/HeaderTitle";

const ImageGrid = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  const allPlaces = ["Place 2", "Place 1", "Place 4", "Place 3", "Place 5"];

  useEffect(() => { fetchCategories(); }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${backend_url}/api/designpatterns`);
      setCategories(response.data);
    } catch (error) { console.error("Error fetching categories:", error); }
  };

  const placeMap = {};
  categories.forEach((c) => { placeMap[c.placeTo] = c; });

  return (
    <section className="relative overflow-hidden py-14 px-4 sm:px-8 lg:px-16 bg-white">

      {/* Ambient blobs */}
      <div className="absolute -top-24 right-0 w-80 h-80 rounded-full blur-3xl opacity-20 pointer-events-none"
        style={{ background: "radial-gradient(circle,#EEE5FA,transparent)" }} />
      <div className="absolute bottom-0 -left-16 w-72 h-72 rounded-full blur-3xl opacity-15 pointer-events-none"
        style={{ background: "radial-gradient(circle,#F6F1FE,transparent)" }} />

      {/* Ghost watermark */}
      <p className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-black whitespace-nowrap pointer-events-none select-none"
        style={{
          fontSize: "clamp(60px,13vw,170px)",
          color: "transparent",
          WebkitTextStroke: "1px rgba(124,58,237,0.04)",
          letterSpacing: "-0.04em",
        }}>
        PATTERNS
      </p>

      <div className="relative max-w-7xl mx-auto">

        {/* Header — shared serif style */}
        <div className="mb-8">
          <HeaderTitle Header="Shop By Design Patterns" />
        </div>

        {/* ── Mobile: 2-col grid, center spans full width on top ── */}
        <div className="grid grid-cols-2 gap-3 md:hidden">
          {/* Center card — full width on mobile */}
          {(() => {
            const item = placeMap["Place 1"];
            return (
              <div
                className="col-span-2 group"
                onClick={() => item?.routeTo && navigate(`/collections/${item.routeTo}`)}
                style={{ cursor: item?.routeTo ? "pointer" : "default" }}
              >
                <div className="relative rounded-2xl overflow-hidden h-[260px] transition-all duration-400"
                  style={{ boxShadow: "0 4px 20px rgba(0,0,0,0.14)" }}>
                  {item ? (
                    <>
                      <img loading="lazy" crossOrigin="anonymous" src={item.image} alt={item.collectionName}
                        className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-600" />
                      <div className="absolute inset-0 pointer-events-none"
                        style={{ background: "linear-gradient(to top,rgba(5,2,20,0.88) 0%,rgba(5,2,20,0.2) 45%,transparent 68%)" }} />
                      <div className="absolute bottom-0 left-0 right-0 p-4">
                        <p className="text-[9px] font-bold tracking-[0.25em] uppercase mb-1" style={{ color: "#D6C3F0" }}>Design Pattern</p>
                        <p className="text-white font-bold text-base leading-tight">{item.collectionName}</p>
                        <p className="text-white/50 text-[11px] mt-1">Starting from ₹{item.startingFrom}</p>
                      </div>
                    </>
                  ) : <div className="absolute inset-0 bg-gray-50 rounded-2xl" />}
                </div>
              </div>
            );
          })()}

          {/* 4 side cards in 2x2 */}
          {["Place 2", "Place 4", "Place 3", "Place 5"].map((place, i) => {
            const item = placeMap[place];
            return (
              <div
                key={i}
                className="group"
                onClick={() => item?.routeTo && navigate(`/collections/${item.routeTo}`)}
                style={{ cursor: item?.routeTo ? "pointer" : "default" }}
              >
                <div className="relative rounded-2xl overflow-hidden h-[160px] transition-all duration-400"
                  style={{ boxShadow: "0 2px 12px rgba(0,0,0,0.10)" }}>
                  {item ? (
                    <>
                      <img loading="lazy" crossOrigin="anonymous" src={item.image} alt={item.collectionName}
                        className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-600" />
                      <div className="absolute inset-0 pointer-events-none"
                        style={{ background: "linear-gradient(to top,rgba(5,2,20,0.82) 0%,rgba(5,2,20,0.18) 55%,transparent 80%)" }} />
                      <div className="absolute bottom-0 left-0 right-0 p-3">
                        <p className="text-[8px] font-bold tracking-[0.2em] uppercase mb-0.5" style={{ color: "#D6C3F0" }}>Design</p>
                        <p className="text-white font-bold text-xs leading-tight">{item.collectionName}</p>
                        <p className="text-white/50 text-[10px] mt-0.5">₹{item.startingFrom}</p>
                      </div>
                    </>
                  ) : <div className="absolute inset-0 bg-gray-50 rounded-2xl" />}
                </div>
              </div>
            );
          })}
        </div>

        {/* ── Desktop: 4-col asymmetric mosaic ── */}
        <div className="hidden md:grid md:grid-cols-4 gap-4">
          {allPlaces.map((place, index) => {
            const item = placeMap[place];
            const isCenter = index === 1;

            return (
              <div
                key={index}
                onClick={() => item?.routeTo && navigate(`/collections/${item.routeTo}`)}
                className={`group ${isCenter ? "md:col-span-2 md:row-span-2" : ""}`}
                style={{ cursor: item?.routeTo ? "pointer" : "default" }}
              >
                {item ? (
                  <div
                    className={`relative rounded-3xl overflow-hidden transition-all duration-500
                      ${isCenter
                        ? "h-[440px] md:h-[520px] lg:h-[600px] md:mt-10"
                        : "h-[240px] md:h-[250px] lg:h-[280px]"}`}
                    style={{ boxShadow: "0 4px 24px rgba(0,0,0,0.12)" }}
                    onMouseEnter={e => {
                      e.currentTarget.style.boxShadow =
                        "0 0 0 2.5px rgba(168,85,247,0.62), 0 20px 52px rgba(124,58,237,0.26)";
                      e.currentTarget.style.transform = "translateY(-6px)";
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.boxShadow = "0 4px 24px rgba(0,0,0,0.12)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    {/* Image */}
                    <img
                      loading="lazy"
                      crossOrigin="anonymous"
                      src={item.image}
                      alt={item.collectionName}
                      className={`absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out
                        ${isCenter ? "object-top" : "object-center"}`}
                    />

                    {/* Dark gradient */}
                    <div className="absolute inset-0 pointer-events-none"
                      style={{
                        background: isCenter
                          ? "linear-gradient(to top,rgba(5,2,20,0.88) 0%,rgba(5,2,20,0.22) 42%,transparent 66%)"
                          : "linear-gradient(to top,rgba(5,2,20,0.82) 0%,rgba(5,2,20,0.22) 52%,transparent 78%)",
                      }} />

                    {/* Purple hover tint */}
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-400 pointer-events-none"
                      style={{ background: "linear-gradient(to top,rgba(109,40,217,0.52) 0%,rgba(109,40,217,0.08) 55%,transparent 80%)" }} />

                    {/* Bottom text */}
                    <div className={`absolute bottom-0 left-0 right-0 z-10 ${isCenter ? "p-6 lg:p-7" : "p-4"}`}>
                      {isCenter && <div className="w-8 h-[2px] mb-3 rounded-full" style={{ background: "#9E79D2" }} />}
                      <p className={`font-bold tracking-[0.25em] uppercase mb-1.5 ${isCenter ? "text-[10px]" : "text-[9px]"}`}
                        style={{ color: "#D6C3F0" }}>
                        Design Pattern
                      </p>
                      <h3 className={`text-white font-bold leading-snug
                        ${isCenter ? "text-lg sm:text-xl lg:text-2xl" : "text-sm lg:text-[15px]"}`}>
                        {item.collectionName}
                      </h3>
                      <p className={`mt-1 ${isCenter ? "text-white/55 text-sm" : "text-white/50 text-[11px]"}`}>
                        Starting from ₹{item.startingFrom}
                      </p>

                      {isCenter && (
                        <div className="mt-4 opacity-0 group-hover:opacity-100 translate-y-3 group-hover:translate-y-0
                                        transition-all duration-300">
                          <span className="inline-flex items-center gap-2 text-white text-sm font-bold
                                           px-5 py-2.5 rounded-full"
                            style={{ background: "rgba(255,255,255,0.14)", border: "1px solid rgba(255,255,255,0.28)" }}>
                            Explore Collection <FiArrowUpRight size={14} />
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className={`rounded-3xl border border-dashed border-purple-100 bg-purple-50/20
                    ${isCenter ? "h-[520px] lg:h-[600px] md:mt-10" : "h-[250px] lg:h-[280px]"}`} />
                )}
              </div>
            );
          })}
        </div>

        {/* Bottom rule */}
        <div className="mt-10 flex items-center gap-4">
          <div className="flex-1 h-px"
            style={{ background: "linear-gradient(to right,rgba(124,58,237,0.3),transparent)" }} />
          <span className="text-purple-300 text-[10px] font-bold tracking-[0.3em] uppercase">
            {categories.length} Patterns
          </span>
          <div className="flex-1 h-px"
            style={{ background: "linear-gradient(to left,rgba(124,58,237,0.3),transparent)" }} />
        </div>
      </div>
    </section>
  );
};

export default ImageGrid;
